package com.esoris.kmpmoout.navigation

import org.koin.dsl.module

val navigationModule = module {

    single {
        NavManager()
    }
}